
import { motion } from 'framer-motion';

const FinalCTA = () => {
  return (
    <section className="relative py-32 overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/87737732dd0b860ac13a09dff20125a4.jpg"
          alt="RBF Express - Logística Empresarial"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-[#1a237e]/90"></div>
      </div>

      <div className="absolute top-10 left-10 w-32 h-32 border-4 border-white/5 rounded-full"></div>
      <div className="absolute bottom-10 right-10 w-48 h-48 border-4 border-white/5 rounded-full"></div>
      <div className="absolute top-1/2 left-1/4 w-24 h-24 bg-white/5 transform rotate-45"></div>

      <div className="container mx-auto px-6 lg:px-20 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center max-w-4xl mx-auto"
        >
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6 leading-tight">
            Sua empresa não pode parar por falhas logísticas.
            <br />
            Fale agora com a RBF Express e tenha um parceiro confiável.
          </h2>
          <p className="text-xl text-white/90 mb-10 leading-relaxed">
            Mais de 15 anos garantindo agilidade, segurança e pontualidade para empresas do Sudeste
          </p>
          <a
            href="https://wa.me/5512991064271?text=Ol%C3%A1!%20Gostaria%20de%20um%20or%C3%A7amento%20para%20transporte%20de%20pe%C3%A7as%2Finsumos%2Fdocumentos%20para%20minha%20empresa."
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center bg-[#ff6f00] text-white px-6 sm:px-12 py-4 sm:py-5 rounded-xl font-bold text-base sm:text-xl hover:bg-[#e66300] transition-all hover:shadow-2xl hover:scale-105 whitespace-nowrap cursor-pointer w-full sm:w-auto max-w-full"
          >
            <i className="ri-whatsapp-fill text-2xl sm:text-3xl mr-2 sm:mr-4"></i>
            <span className="truncate">Atendimento Imediato via WhatsApp</span>
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default FinalCTA;
